<!-- (click)="click.emit()" -->
<button [type]="type" [disabled]="disabled || loading" [ngClass]="{'loading': loading}"
  [class]="class + ' ' + buttonclass" [title]="label">
  <i *ngIf="icon" [class]="icon" [ngClass]="{'mr-2': label}"></i> {{ label }}
</button>